export default __webpack_public_path__ + "static/media/mobile_banking_short.4cb7d962.jpg";